'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { safeTranslateColor } from '@/lib/helpers/sanitize-i18n-keys'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useCallback } from 'react'

interface ProductInfoSuggestVariantsProps {
  variants: Array<{
    imageUrl: string
    title: string
    id: string
  }>
  selectedVariantId?: string
  onVariantChange?: (variantId: string) => void
}

export const ProductInfoSuggestVariants: React.FC<
  ProductInfoSuggestVariantsProps
> = ({ variants, selectedVariantId, onVariantChange }) => {
  const t = useTranslations('title')
  const tColorTitle = useTranslations()
  // Sử dụng selectedVariantId từ props, hoặc mặc định là item đầu tiên
  const selectedId =
    selectedVariantId || (variants.length > 0 ? variants[0].id : '')

  const handleChangeVariant = useCallback(
    (variantId: string) => {
      if (onVariantChange) {
        onVariantChange(variantId)
      }
    },
    [onVariantChange]
  )

  return (
    <div>
      <p className='mb-1 font-sans text-sm leading-4.5 text-neutral-600 lg:mb-2 lg:text-base lg:leading-5'>
        <span className='text-neutral-900'>{t('color')}:</span>{' '}
        <span className='font-semibold'>
          {safeTranslateColor(
            tColorTitle,
            variants.find((v) => v.id === selectedId)?.title || ''
          )}
        </span>
      </p>

      <ul className='flex flex-wrap gap-2.5 gap-y-1.5 lg:gap-4 lg:gap-y-3'>
        {variants.map((variant) => {
          const isActive = selectedId === variant.id
          return (
            <ProductInfoSuggestVariantItem
              key={variant.id}
              isActive={isActive}
              onClick={() => handleChangeVariant(variant.id)}
              title={variant.title}
              imageUrl={variant.imageUrl}
            />
          )
        })}
      </ul>
    </div>
  )
}

interface ProductInfoSuggestVariantItemProps {
  isActive?: boolean
  onClick?: () => void
  title: string
  imageUrl: string
}

const ProductInfoSuggestVariantItem = ({
  isActive,
  onClick,
  imageUrl,
  title,
}: ProductInfoSuggestVariantItemProps) => {
  return (
    <li>
      <button
        onClick={onClick}
        className={cn(
          'block h-9 cursor-pointer rounded-full border-2 border-neutral-600/30 p-0.5 transition-colors hover:border-primary',
          isActive && 'border-primary'
        )}
      >
        <Image
          src={ImageHelper.getImageUrl(imageUrl, '50_67')}
          alt={`color ${title}`}
          width={50}
          height={30}
          className='h-full w-[50px] rounded-full object-cover'
          unoptimized
        />
      </button>
    </li>
  )
}
